import { joinPath } from '../../../utils/nodePath.js';
import { isViewportBoundary } from './viewportBoundary.js';
export function collectNestedViewportPaths(node, path) {
    const found = [];
    const walk = (children, parentPath) => {
        for (const child of children) {
            const childPath = joinPath(parentPath, child.name);
            if (isViewportBoundary(child.type)) {
                found.push(childPath);
                // A viewport nested in that one is its own pass's dependency, and the
                // driver resolves transitive chains.
                continue;
            }
            walk(child.children, childPath);
        }
    };
    walk(node.children, path);
    return found;
}
//# sourceMappingURL=nestedViewportPaths.js.map